import { lazy } from 'react';

const ChangePasswordDesktop = lazy(() =>
  import(
    /* webpackChunkName: "ChangePasswordDesktop" */ '@common2/Authorization/ChangePassword/ChangePassword'
  )
);

export default ChangePasswordDesktop;
